// extracted by mini-css-extract-plugin
var _1 = "muQds2IhanOB1y027e_N";
var _2 = "ff0pGcw7rvMHfRHbYubc";
export { _1 as "table", _2 as "totalRow" }
